const babyTemps = [
  {
    id: 1,
    text: "We are only able to assist directly with orders placed on the HP Store and received within the last 30 days.",
  },
  {
    id: 2,
    text: "To speak directly with a Sales Agent, you may contact them at 0207 660 3859 (Option 1 and Option 2 for Sales) or by writing them via email at hpstoresalesuk@hp.com.",
  },
  {
    id: 3,
    text: "Our apologies for the inconveniences you have seen with this order. ",
  },
  {
    id: 4,
    text: "For more immediate assistance, our Post Sales phone line is open from 9am until 5:30pm and can be reached at 0207 660 3859 (Option 1 and then Option 1).",
  },
  {
    id: 5,
    text: "Kindly note that this email address does not receive replies. If you wish to reply to the email, please call us at 0207 660 3859 or use our chat service, available from 9:00 am to 5:30 pm.",
  },
];

export { babyTemps };
